fragment WorkOsFragment on WorkOs {
    organizationId
    domainInfo {
        domains {
            domain
            isVerified
            isMarkedAsPinned
        }
        adminPortal
    }
    sso {
        canSetup
        isConfigured
        isRequired
        adminPortal
        exemptUsers {
            id
            name
        }
        nonExemptUsers {
            id
            name
        }
    }
    directorySync {
        canSetup
        isConfigured
        adminPortal
        defaultRole {
            id
            name
        }
        lastSyncTime
    }
}
